// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Calendar_fasting_overlay__i03SH","container":"Calendar_fasting_container__35pow","button":"Calendar_fasting_button__379M2","icon":"Calendar_fasting_icon__2PRag"};